import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = '职唛AI - AI驱动的智能求职平台 | 模拟面试 | 简历优化',
  description = '职唛AI提供AI面试准备服务:智能简历诊断、面试押题、模拟面试、会议助手。已帮助10,000+求职者成功拿到名企offer,面试通过率提升95%',
  keywords = 'AI面试,模拟面试,简历优化,面试准备,求职辅导,面试技巧,简历诊断,职唛AI',
  canonicalUrl = 'https://zhimai.ai',
  ogImage = 'https://zhimai.ai/images/og-image.png',
  structuredData = null,
}) => {
  const defaultStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '职唛AI',
    legalName: '杭州元烁智创科技有限公司',
    url: 'https://zhimai.ai',
    logo: 'https://zhimai.ai/images/logos/logo.svg',
    description: 'AI驱动的智能求职平台,提供模拟面试、简历诊断、面试押题等服务',
    address: {
      '@type': 'PostalAddress',
      addressLocality: '杭州',
      addressRegion: '浙江省',
      addressCountry: 'CN'
    },
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@zhispark.com',
      contactType: '客户服务',
      availableLanguage: ['Chinese', 'English', 'Japanese', 'Korean']
    }
  };

  return (
    <Helmet>
      <html lang="zh-CN" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content="职唛AI" />
      <link rel="canonical" href={canonicalUrl} />
      <script type="application/ld+json">
        {JSON.stringify(structuredData || defaultStructuredData)}
      </script>
    </Helmet>
  );
};

export default SEO;
